(function() {
    'use strict';

    angular.module('app').factory('StylePricingFactory', StylePricingFactory);

    function StylePricingFactory($resource) {
        return $resource('/style/:id');
    }
})();
